import React from "react"
import Pages from "@material-ui/lab/Pagination"

import { withPagination } from "./withPagination"
import { Wrapper } from "./PaginationStyles"

export const Pagination = withPagination(({ count, page, handleChange }) => (
  <Wrapper>
    <Pages count={count} page={page} onChange={handleChange} shape="rounded" />
  </Wrapper>
))
